import styled from '@emotion/styled'

export const UploadWrapper = styled.div`
  text-align: right;
  width: 100%;
  .ant-upload {
    width: 100%;
    .ant-btn {
      width: 100%;
    }
  }
  .ant-upload-list {
    text-align: left;
  }

  .ant-upload-disabled {
    display: none;
  }
`

export const UploadWrapperHideList = styled.div`
  .ant-upload-list {
    display: none;
  }
`

export const DisplayList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const DisplayListItem = styled.li`
  .fileName {
    font-weight: bold;
  }
  .url {
    font-style: italic;
  }
`

export const FileList = styled.div`
  .ant-upload-list-item {
    margin-top: 0;
  }
  .ant-upload-span {
    display: flex;
    align-items: center;
    & > a {
      padding-left: 5px;
    }
  }
`
